/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../app/layout/tabs/tab.component';
const styles_TabComponent:any[] = ['.pane[_ngcontent-%COMP%] {\n        padding: 0em;\n      }\n      .tab-content[_ngcontent-%COMP%] {\n        height: 100%;\n      }'];
export const RenderType_TabComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,styles:styles_TabComponent,
    data:{}});
function View_TabComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,16777216,(null as any),(null as any),3,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(1,540672,(null as any),0,i1.NgTemplateOutlet,[i0.ViewContainerRef],{ngTemplateOutlet:[0,
          'ngTemplateOutlet'],ngOutletContext:[1,'ngOutletContext']},(null as any)),
      i0.ɵpod(2,{data:0,tabIndex:1}),(_l()(),i0.ɵted(-1,(null as any),['\n      ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = _co.template;
        const currVal_1:any = _ck(_v,2,0,_co.dataContext,_co.tabIndex);
        _ck(_v,1,0,currVal_0,currVal_1);
      },(null as any));
}
export function View_TabComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),6,'div',[['class','pane tab-content']],[[8,'hidden',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
      (null as any),['\n      '])),i0.ɵncd((null as any),0),(_l()(),i0.ɵted(-1,(null as any),
      ['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_TabComponent_1)),i0.ɵdid(6,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
      i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),
      ['\n    '])),(_l()(),i0.ɵted(-1,(null as any),['\n  ']))],(_ck,_v) => {
    var _co:i2.TabComponent = _v.component;
    const currVal_1:any = _co.template;
    _ck(_v,6,0,currVal_1);
  },(_ck,_v) => {
    var _co:i2.TabComponent = _v.component;
    const currVal_0:boolean = !_co.active;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_TabComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'my-tab',([] as any[]),
      (null as any),(null as any),(null as any),View_TabComponent_0,RenderType_TabComponent)),
      i0.ɵdid(1,49152,(null as any),0,i2.TabComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const TabComponentNgFactory:i0.ComponentFactory<i2.TabComponent> = i0.ɵccf('my-tab',
    i2.TabComponent,View_TabComponent_Host_0,{title:'tabTitle',active:'active',isCloseable:'isCloseable',
        template:'template',dataContext:'dataContext',tabIndex:'tabIndex'},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvbGF5b3V0L3RhYnMvdGFiLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2xheW91dC90YWJzL3RhYi5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2xheW91dC90YWJzL3RhYi5jb21wb25lbnQudHMuVGFiQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9Vc2Vycy9xdWFuaG9hbmcvemVuaWZ5L3JlcG9zL2NsaWVudC1maW5hbC9zcmMvYXBwL2xheW91dC90YWJzL3RhYi5jb21wb25lbnQudHMuVGFiQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGRpdiBbaGlkZGVuXT1cIiFhY3RpdmVcIiBjbGFzcz1cInBhbmUgdGFiLWNvbnRlbnRcIj5cbiAgICAgIDxuZy1jb250ZW50PjwvbmctY29udGVudD5cbiAgICAgIDxuZy1jb250YWluZXJcbiAgICAgICAgKm5nSWY9XCJ0ZW1wbGF0ZVwiXG4gICAgICAgIFtuZ1RlbXBsYXRlT3V0bGV0XT1cInRlbXBsYXRlXCJcbiAgICAgICAgW25nT3V0bGV0Q29udGV4dF09XCJ7IGRhdGE6IGRhdGFDb250ZXh0LCB0YWJJbmRleDogdGFiSW5kZXggfVwiXG4gICAgICA+XG4gICAgICA8L25nLWNvbnRhaW5lcj5cbiAgICA8L2Rpdj5cbiAgIiwiPG15LXRhYj48L215LXRhYj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDR007TUFBQTthQUFBO1VBQUE7YUFHRSx3QkFDRDs7O1FBRkM7UUFDQTtRQUhGLFdBRUUsVUFDQSxTQUhGOzs7O29CQUhOLDhDQUNJO01BQUE7VUFBQSw4REFBaUQ7TUFBQSxvQ0FDL0Msa0JBQXlCO01BQUEsZUFDekI7TUFBQSw2QkFBQTtvQkFBQSxtQ0FLZTtNQUFBLGFBQ1g7O0lBTEY7SUFERixXQUNFLFNBREY7OztJQUZHO0lBQUwsV0FBSyxTQUFMOzs7O29CQ0RKO01BQUE7YUFBQTtVQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/layout/tabs/tab.component.ngfactory.ts